import React, { useEffect } from 'react';
import { View, Text, StyleSheet, Image } from 'react-native';

import WebEKYCQRCodeSTG from 'shared/assets/images/web-ekyc-qr-code-stg.png';
import WebEKYCQRCode from 'shared/assets/images/web-ekyc-qr-code.png';
import PaidyAppQRCode from 'shared/assets/images/web-to-app-kyc-qr-code.png';
import PaidyAppQRCodeSTG from 'shared/assets/images/web-to-app-qr-code-kyc-stg.png';
import { SELECTED_METHOD } from 'shared/constants/ekyc';
import Button from 'shared/modules/common/components/atoms/Button';

type Props = {
  onNextButtonPress: () => void;
  selectedMethod: number;
  onFocus?: () => void;
  onBlur?: () => void;
};

const QRCodeStage = (props: Props) => {
  const { onNextButtonPress, selectedMethod, onFocus, onBlur } = props;

  useEffect(() => {
    onFocus?.();

    return () => onBlur?.();
  }, []);

  return (
    <View style={styles.root}>
      <Text style={styles.mainTitle}>
        {`スマートフォンのカメラで\nQRコードを読み取って、\n本人確認を進めてください。`}
      </Text>
      <View style={styles.content}>
        <View style={styles.qrContainer}>
          <Image
            source={{
              uri:
                selectedMethod === SELECTED_METHOD.MOBILE_APP
                  ? process.env.WEB_ENV === 'production'
                    ? PaidyAppQRCode
                    : PaidyAppQRCodeSTG
                  : process.env.WEB_ENV === 'production'
                  ? WebEKYCQRCode
                  : WebEKYCQRCodeSTG,
            }}
            style={styles.qr}
          />
        </View>
      </View>

      <View style={styles.buttonContainer}>
        <Button
          variant="primary"
          title="閉じる"
          style={styles.nextButton}
          onPress={onNextButtonPress}
          id="ekyc-onboarding-qr-code-stage-next-button"
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    flexDirection: 'column',
    flexGrow: 1,
  },
  mainTitle: {
    fontSize: 20,
    fontWeight: '600',
    marginBottom: 24,
    color: '#000',
    textAlign: 'center',
  },
  nextButton: {
    maxWidth: 296,
    alignSelf: 'center',
  },
  content: {
    padding: 66,
  },
  qrContainer: {
    padding: 24,
    backgroundColor: '#fff',
    borderRadius: 16,
  },
  qr: { height: 196, width: 196 },
  buttonContainer: {
    flex: 1,
    flexDirection: 'row',
    flexGrow: 1,
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
});

export default QRCodeStage;
